<template>
    <div class="page_wrap">
        <div class="page_main">
            <div class="main_content">
                <router-view></router-view>
            </div>
            <div class="main_footer hidden-xs-only">
                <div class="footer_main">
                    <div class="footer_title">懒人办公 - 解放大脑和双手！</div>
                    <div class="footer_desc">极简操作，让写作变得从未如此简单!</div>
                </div>
                <router-link to="/">
                    <el-button style="width:140px;" type="info">立即加入</el-button>
                </router-link>
            </div>
            <div class="main_footer m_footer hidden-sm-and-up">
                <div class="footer_main">
                    <div class="footer_title">懒人办公 - 解放大脑和双手！</div>
                    <div class="footer_desc">极简操作，让写作变得从未如此简单!</div>
                </div>
                <router-link to="/">
                    <el-button size="mini" style="width:70px;" type="info">加入</el-button>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import 'element-ui/lib/theme-chalk/display.css';
    export default {
        data() {
            return {
                
            }
        },
        created() {
        },
        methods: {
            
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .page_wrap{
        min-height: 100vh;
        background-color: #f5f5f5;
        .page_main{
            padding-bottom: 30px;
            .main_content{
                margin-bottom: 30px;
            }
            .main_footer{
                width: 768px;
                margin: 0 auto;
                background-color: #fff;
                border-radius: 5px;
                padding: 0 56px 0 32px;
                display: flex;
                align-items: center;
                height: 160px;
                flex-shrink: 0;
                &.m_footer{
                    margin: 0 20px;
                    height: 70px;
                    padding: 0 12px;
                    width: auto;
                    .footer_main{
                        .footer_title,.footer_desc{
                            font-size: 12px;
                            line-height: 24px;
                        }
                    }
                }
                .footer_main{
                    flex-grow: 1;
                    .footer_title{
                        font-size: 22px;
                        line-height: 60px;
                        font-weight: bold;
                    }
                    .footer_desc{
                        font-size: 16px;
                        color: #999;
                        line-height: 54px;
                    }
                }
            }
        }
    }
</style>